import React, { useState, useEffect } from 'react';
import { styled } from '@mui/system';
import Dialog from '@mui/material/Dialog';
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider, createTheme } from '@mui/material/styles'; 

const theme = createTheme();




const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: "16px",
  maxWidth: "864px",
  background: "#3c8dbc",
  color: "#fff",
}));

const CheckAddDialog = (props) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const initialFormState = {
    id: null,
    name: '',
    category: '',
    subCategory: '',
    questionType: '',
  };
  const [catvalue, setCategoryValue] = useState('');
  let [newCatvalue, setNewCategoryValue] = useState('');
  const [subCatvalue, setSubCategoryValue] = useState('');
  let [newSubCatvalue, setNewSubCategoryValue] = useState('');
  let [qType, setQType] = useState('');
  const [placeHolder, setPlaceHolder] = useState('Add');
  const [questionInput, setInputValue] = useState('');
  const [user, setUser] = useState(initialFormState);

  const [subCat, setSubCat] = useState([]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setInputValue(event.target);
    setUser({ ...user, [name]: value.replace(/[^\w\s]/gi, "") });
  };
  useEffect(() => {
    if (catvalue !== '') {
      setNewCategoryValue('');
    }
    if (subCatvalue !== '') {
      setNewCategoryValue('');
    }
  }, [catvalue, subCatvalue]);
  const handleCatChange = (event) => {
    setNewCategoryValue('');
    setPlaceHolder('Add');
    const { category, value } = event.target.value;
    setUser({ ...user, [category]: value });

    props.users.map((index) => {
      let catVar = index.category === event.target.value;
      setCategoryValue(event.target.value);

      if (catVar) {
        setSubCat(index.subCategory);
      }
    });
  };

  const handleSubCatChange = (event) => {
    const { subCategory, value } = event.target.value;
    setSubCategoryValue(event.target.value);
    setNewSubCategoryValue('');
    setUser({ ...user, [subCategory]: value });
  };
  const handleNewCatvalue = (e) => {
    setNewCategoryValue(e.target.value.replace(/[^\w\s]/gi, ""));
  };
  const handleNewSubCatvalue = (e) => {
    setNewSubCategoryValue(e.target.value.replace(/[^\w\s]/gi, ""));
  };
  const handleTypeChange = (e) => {
    setQType(e.target.value);
  };

  const handleSubmit = () => {};

  return (
    <ThemeProvider theme={theme}>
    <div>
      <button
        variant='outlined'
        color='primary'
        className='btn btn-secondary deca-btn-yellow'
        onClick={handleClickOpen}
        disabled={props.users.length === 0}
      >
        Add Questions
      </button>

      <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          style={{width:"100%"}}
        >
        <DialogTitle
          className='MuiTgt'
          style={{ color: 'white' }}
          onClose={handleClose}
        >
          <div className='MuiTgt'> Checklist Questions</div>
        </DialogTitle>
        <form
          className=''
          style={{ backgroundColor: '#eaf7fdcc' }}
          onSubmit={(event) => {
            event.preventDefault();
            //if (!user.name) return;
            if (catvalue === '' && newCatvalue === '') {
              toast.error('Please select the category!!', {
                position: 'bottom-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            } else if (subCatvalue === '' && newSubCatvalue === '') {
              toast.error('Please select the subcategory!', {
                position: 'bottom-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            } else if (questionInput === '') {
              toast.error('Please enter the question!', {
                position: 'bottom-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            } else if (
              props.checkName === 'Monthly SOD' ||
              props.checkName === 'Diagnosis - Store Handovers' ||
              props.checkName === 'Diagnosis SOD'
            ) {
              if (qType === '') {
                toast.error('Please enter the question!', {
                  position: 'bottom-right',
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              } else {
                if (catvalue === '') {
                  user['category'] = newCatvalue;
                } else {
                  user['category'] = catvalue;
                }
                if (subCatvalue === '') {
                  user['subCategory'] = newSubCatvalue;
                } else {
                  user['subCategory'] = subCatvalue;
                }
                user['questionType'] = qType;
                //user['category'] = catvalue;
                //user['subCategory'] = subCatvalue;

                props.addUser(user);
                setUser(initialFormState);
                handleClose();
              }
            } else {
              if (catvalue === '') {
                user['category'] = newCatvalue;
              } else {
                user['category'] = catvalue;
              }
              if (subCatvalue === '') {
                user['subCategory'] = newSubCatvalue;
              } else {
                user['subCategory'] = subCatvalue;
              }
              user['questionType'] = qType;
              //user['category'] = catvalue;
              //user['subCategory'] = subCatvalue;

              props.addUser(user);
              setUser(initialFormState);
              handleClose();
            }
          }}
        >
          <select
            className='input-cls-select'
            onChange={handleCatChange}
            defaultValue={'DEFAULT'}
            style={{ marginRight: '8px' }}
            disabled={newCatvalue}
          >
            <option value='' selected>
              Select Category
            </option>
            {props.users.map((index) => (
              <option value={index.category} key={index.category}>
                {index.category}
              </option>
            ))}
          </select>
          <select
            className='input-cls-select'
            onChange={handleSubCatChange}
            defaultValue={'DEFAULT'}
            disabled={newSubCatvalue}
          >
            <option value='' selected>
              Select SubCategory
            </option>
            {subCat.map((index1) => {
              return (
                <option key={index1.subCategory} value={index1.subCategory}>
                  {index1.subCategory}
                </option>
              );
            })}
          </select>

          <input
            className='input-cls-select'
            type='text'
            name='category'
            onChange={handleNewCatvalue}
            maxLength="100"
            placeholder={`${placeHolder} category`}
            disabled={catvalue}
          />
          <input
            className='input-cls-select'
            type='text'
            name='subcategory'
            onChange={handleNewSubCatvalue}
            placeholder={`${placeHolder} subcategory`}
            disabled={subCatvalue}
          />
          <select
            className='input-cls-select input-cls-select-width'
            onChange={handleTypeChange}
            style={
              props.checkName === 'Monthly SOD' ||
              props.checkName === 'Diagnosis - Store Handovers' ||
              props.checkName === 'Diagnosis SOD'
                ? { display: 'block' }
                : { display: 'none' }
            }
          >
            <option value='' selected>
              Question Type
            </option>
            <option value='Safety'>Safety</option>
            <option value='Image'>Image</option>
          </select>
          <textarea
            type='text'
            name='name'
            value={user.name}
            className='input-cls'
            placeholder='Add new question'
            onChange={handleInputChange}
            maxLength="1000"
            fontFamily='Roboto condensed'
          />

          <button
            className='btn btn-secondary deca-btn-yellow'
            style={{ marginLeft: '75%', marginTop: '5%' }}
            onClick={handleSubmit}
          >
            Add Question
          </button>
        </form>{' '}
      </Dialog>
    </div>
    </ThemeProvider>
  );
};
export default CheckAddDialog;
